import * as T from 'modules/Marketing/types'

const stateData: T.StateInfo[] = [
  {
    name: 'California',
    route: 'california',
    imgUrl: 'amazon/assets/c/1920/homelister-california.jpg',
    medianHomePrice: 850000,
  },
  {
    name: 'Connecticut',
    route: 'connecticut',
    imgUrl: 'amazon/assets/c/1920/homelister-other-states.jpg',
    medianHomePrice: 320000,
  },
  {
    name: 'Delaware',
    route: 'delaware',
    imgUrl: 'amazon/assets/c/1920/homelister-other-states.jpg',
    medianHomePrice: 320000,
  },
  {
    name: 'Florida',
    route: 'florida',
    imgUrl: 'amazon/assets/c/1920/homelister-florida.jpg',
    medianHomePrice: 320000,
  },
  {
    name: 'Georgia',
    route: 'georgia',
    imgUrl: 'amazon/assets/c/1920/homelister-other-states.jpg',
    medianHomePrice: 320000,
  },
  // {
  //   name: 'Illinois',
  //   route: 'illinois',
  //   imgUrl: 'amazon/assets/c/1920/homelister-other-states.jpg',
  //   medianHomePrice: 263835,
  // },
  {
    name: 'Maryland',
    route: 'maryland',
    imgUrl: 'amazon/assets/c/1920/homelister-other-states.jpg',
    medianHomePrice: 400000,
  },
  {
    name: 'Massachusetts',
    route: 'massachusetts',
    imgUrl: 'amazon/assets/c/1920/homelister-other-states.jpg',
    medianHomePrice: 550000,
  },
  {
    name: 'Michigan',
    route: 'michigan',
    imgUrl: 'amazon/assets/c/1920/homelister-other-states.jpg',
    medianHomePrice: 234954,
  },
  {
    name: 'New Jersey',
    route: 'new-jersey',
    imgUrl: 'amazon/assets/c/1920/homelister-other-states.jpg',
    medianHomePrice: 400000,
  },
  {
    name: 'New Mexico',
    route: 'new-mexico',
    imgUrl: 'amazon/assets/c/1920/homelister-other-states.jpg',
    medianHomePrice: 550000,
  },
  {
    name: 'New York',
    route: 'new-york',
    imgUrl: 'amazon/assets/c/1920/homelister-new-york.jpg',
    medianHomePrice: 750000,
  },
  {
    name: 'North Carolina',
    route: 'north-carolina',
    imgUrl: 'amazon/assets/c/homelister-northcarolina.jpg',
    medianHomePrice: 320000,
  },
  {
    name: 'Oregon',
    route: 'oregon',
    imgUrl: 'amazon/assets/c/1920/homelister-other-states.jpg',
    medianHomePrice: 550000,
  },
  {
    name: 'Pennsylvania',
    route: 'pennsylvania',
    imgUrl: 'amazon/assets/c/1920/homelister-other-states.jpg',
    medianHomePrice: 320000,
  },
  {
    name: 'Texas',
    route: 'texas',
    imgUrl: 'amazon/assets/c/1920/homelister-texas.jpg',
    medianHomePrice: 320000,
  },
  {
    name: 'Washington',
    route: 'washington',
    imgUrl: 'amazon/assets/c/1920/homelister-other-states.jpg',
    medianHomePrice: 480000,
  },
  {
    name: 'Washington D.C.',
    route: 'washington-dc',
    imgUrl: 'amazon/assets/c/1920/homelister-other-states.jpg',
    medianHomePrice: 750000,
  },
  {
    name: 'Wisconsin',
    route: 'wisconsin',
    imgUrl: 'amazon/assets/c/1920/homelister-other-states.jpg',
    medianHomePrice: 240000,
  },
]

const constructStateData = () => {
  const stateCampaignData: { [key: string]: T.CampaignInfo } = {}

  const getInfoTitle = (state: string) => {
    switch (state) {
      case 'Utah':
        return 'How Do We Work?'
      default:
        return 'What is HomeLister?'
    }
  }

  const getInfoContent = (state: string) => {
    const freeToTryInfo = "It's always free to try, pay only when you close."
    const infoContent = `a new way to sell your home in ${state}. We'll list your home in the MLS and all real estate search websites, while you keep total control over your own home sale from unlimited changes to your listing, setting your price to talking to buyers directly. You can choose how much additional help you want, whenever you want it. Our flat fee plans start at $599 and unlike offline traditional agents, we are not based on a commission or percentage of your home’s sales price.`

    switch (state) {
      case 'Georgia':
        return `HomeLister is ${infoContent}`
      case 'Utah':
        return `We are ${infoContent} ${freeToTryInfo}`
      default:
        return `HomeLister is ${infoContent} ${freeToTryInfo}`
    }
  }

  stateData.forEach(state => {
    const pageTitle = `Sell Your Home in ${state.name} Today | HomeLister`
    const metaDescription = `We are a new way to sell your home in ${state.name}. We'll list your home in the MLS and all real estate search websites at your discretion. Try HomeLister today.`
    const metaKeywords = `sell your home, ${state.name}, homelister`
    const heroTitle = `Sell Your Home in ${state.name}`
    const heroSubtitle = "It's better, faster, smarter and only low flat fees!"
    const infoTitle = getInfoTitle(state.name)
    const infoContent = getInfoContent(state.name)

    stateCampaignData[state.route] = {
      name: state.name,
      imgUrl: state.imgUrl,
      pageTitle,
      metaDescription,
      metaKeywords,
      heroTitle,
      heroSubtitle,
      infoTitle,
      infoContent,
      stateCampaign: true,
      stateMedianHomePrice: state.medianHomePrice,
    }
  })
  return stateCampaignData
}

const StateCampaignData = constructStateData()

export default StateCampaignData
